// src/routes/AppRoutes.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import HomePage from '../pages/HomePage';
import MainLayout from '../layouts/MainLayout';
import Forbidden from '../pages/Forbidden';
import CompanyList from '../pages/CompanyList';
import Checkout from '../pages/Checkout';
import PolicyDownload from '../pages/PolicyDownload';
import SignIn from '../pages/auth/SignIn';
import ProtectedRoute from '../auth/ProtectedRoute';
import AboutPage from '../pages/AboutPage';
import MotorPage from '../pages/MotorPage';
import MotorDetailsPage from '../pages/MotorDetailsPage';
import ClaimManagment from '../pages/forms/ClaimManagment';
import CreditLife from '../pages/forms/CreditLife';
import Domestic from '../pages/forms/Domestic';
import GroupPersonal from '../pages/forms/GroupPersonal';
import HomeInsurance from '../pages/forms/HomeInsurance';
import LifeInsurance from '../pages/forms/LifeInsurance';
import MedicalInsurance from '../pages/forms/MedicalInsurance';
import PropertyInsurance from '../pages/forms/PropertyInsurance';
import WorkerCompensation from '../pages/forms/WorkerCompensation';
import PersonalAccident from '../pages/forms/PersonalAccident';
import ProjectInsurance from '../pages/forms/ProjectInsurance';
import GigPersonDetailsForm from '../components/GigCompany/PersonalDetailsForm';
import AoPersonDetailsForm from '../components/AoCompany/PersonalDetailsForm';
import TakafulPersonDetailsForm from '../components/TakafulCompany/PersonalDetailsForm';
import GigMotorPersonalDetailForm from '../components/GigCompany/motor/MotorPersonalDetailsForm';
import TakafulMotorPersonalDetailForm from '../components/TakafulCompany/motor/MotorPersonalDetailsForm';
import OquicMotorPersonalDetailForm from '../components/OquicCompany/motor/MotorPersonalDetailsForm';
import OquicPersonDetailsForm from '../components/OquicCompany/PersonalDetailsForm';
import EbridgeMotorPersonalDetailForm from '../components/EbridgeCompany/motor/MotorPersonalDetailsForm';
import TransactionHistory from '../pages/TransactionHistory';
import TransactionHistoryDetail from '../pages/TransactionHistory/Detail';

const AppRoutes = () => {
    const ASSET_BASE = process.env.REACT_APP_CURRENT_ENV || "";
    return (
        <Router basename={ASSET_BASE}>
            <Routes>
                {/* Public Routes */}
                <Route path="" element={<MainLayout><HomePage /></MainLayout>} />
                <Route path="/:id" element={<MainLayout><AboutPage /></MainLayout>} />
                <Route path="/product/:id" element={<MainLayout><MotorPage /></MainLayout>} />
                <Route path="/get-quotes" element={<MainLayout><MotorDetailsPage /></MainLayout>} />
                <Route path="/company-list" element={<MainLayout><CompanyList /></MainLayout>} />
                <Route path="/signin" element={<MainLayout><SignIn /></MainLayout>} />
                <Route path="/signin" element={<MainLayout><SignIn /></MainLayout>} />
                <Route path="/takaful-motor-personal-detail-form" element={<ProtectedRoute requiredRole="user"><MainLayout><TakafulMotorPersonalDetailForm /></MainLayout></ProtectedRoute>} />
                <Route path="/takaful-personal-detail-form" element={<ProtectedRoute requiredRole="user"><MainLayout><TakafulPersonDetailsForm /></MainLayout></ProtectedRoute>} />
                <Route path="/gig-motor-personal-detail-form" element={<ProtectedRoute requiredRole="user"><MainLayout><GigMotorPersonalDetailForm /></MainLayout></ProtectedRoute>} />
                <Route path="/gig-personal-detail-form" element={<ProtectedRoute requiredRole="user"><MainLayout><GigPersonDetailsForm /></MainLayout></ProtectedRoute>} />
                <Route path="/ao-personal-detail-form" element={<ProtectedRoute requiredRole="user"><MainLayout><AoPersonDetailsForm /></MainLayout></ProtectedRoute>} />
                <Route path="/oquic-motor-personal-detail-form" element={<ProtectedRoute requiredRole="user"><MainLayout><OquicMotorPersonalDetailForm /></MainLayout></ProtectedRoute>} />
                <Route path="/ebridge-motor-personal-detail-form" element={<ProtectedRoute requiredRole="user"><MainLayout><EbridgeMotorPersonalDetailForm /></MainLayout></ProtectedRoute>} />
                <Route path="/oquic-personal-detail-form" element={<ProtectedRoute requiredRole=" user"><MainLayout><OquicPersonDetailsForm /></MainLayout></ProtectedRoute>} />
                <Route path="/checkout" element={<ProtectedRoute requiredRole="user"><MainLayout><Checkout /></MainLayout></ProtectedRoute>} />
                <Route path="/checkout/:id" element={<ProtectedRoute requiredRole="user"><MainLayout><Checkout /></MainLayout></ProtectedRoute>} />
                <Route path="/policy-download" element={<ProtectedRoute requiredRole="user"><MainLayout><PolicyDownload /></MainLayout></ProtectedRoute>} />

                <Route path="/transaction-history" element={<MainLayout><TransactionHistory /></MainLayout>} />
                <Route path="/transaction-history/detail" element={<MainLayout><TransactionHistoryDetail /></MainLayout>} />

                <Route path="/product/claims-management" element={<MainLayout ><ClaimManagment /></MainLayout>} />
                <Route path="/product/credit-life" element={<MainLayout ><CreditLife /></MainLayout>} />
                <Route path="/product/domestic" element={<MainLayout ><Domestic /></MainLayout>} />
                <Route path="/product/group-personal-accident" element={<MainLayout ><GroupPersonal /></MainLayout>} />
                <Route path="/product/home-insurance" element={<MainLayout ><HomeInsurance /></MainLayout>} />
                <Route path="/product/life-insurance" element={<MainLayout ><LifeInsurance /></MainLayout>} />
                <Route path="/product/medical" element={<MainLayout ><MedicalInsurance /></MainLayout>} />
                <Route path="/product/property-insurance" element={<MainLayout ><PropertyInsurance /></MainLayout>} />
                <Route path="/product/worker’s-compensation" element={<MainLayout ><WorkerCompensation /></MainLayout>} />
                <Route path="/product/personal-accident" element={<MainLayout ><PersonalAccident /></MainLayout>} />
                <Route path="/product/project-insurance" element={<MainLayout ><ProjectInsurance /></MainLayout>} />
                <Route path="*" element={<MainLayout><Forbidden /></MainLayout>} />
            </Routes>
        </Router>
    );
};

export default AppRoutes;
